import { array, object, string } from '@mojotech/json-type-validation'

export const algorithmCategoryDecoder = object({
  categoryId: string(),
  users: array(string())
})
